import {
  B_19,
  BANNER_DEFAULTS,
  hideB19Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B19_PLASMIC_PROPS = {
  b19Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_19].heading,
    description: "Main heading (B19 only)",
    hidden: hideB19Props,
  },
  b19Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_19].description,
    description: "Description text (B19 only)",
    hidden: hideB19Props,
  },
  b19PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_19].primaryButtonText,
    description: "Primary CTA button text (B19 only)",
    hidden: hideB19Props,
  },
  b19PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_19].primaryButtonUrl,
    description: "Primary CTA button URL (B19 only)",
    hidden: hideB19Props,
  },
  b19BackgroundVector: {
    type: "imageUrl",
    description: "Background vector image (B19 only)",
    hidden: hideB19Props,
  },
};
